import { useCallback } from 'react'

import { useAccount, useChainId } from 'wagmi'

import { GasParams, Hash } from 'types/entities'

import { useNativeCurrency } from 'hooks/token'
import { useCreateTransaction } from 'hooks/wallet'

import { errors } from 'constants/errors'

export function useTopUp() {
  const chainId = useChainId()
  const { address } = useAccount()
  const native = useNativeCurrency()

  const createTransaction = useCreateTransaction()

  return useCallback(
    async (privateKeyAddress: Hash, amount: bigint, gasParams?: GasParams) => {
      if (!address) {
        throw new Error(errors.wallet.WALLET_REQUIRED)
      }

      const txHash = await createTransaction({ gasParams, to: privateKeyAddress, amount })

      return txHash
    },
    [native, createTransaction, address, chainId],
  )
}
